import {Slider} from "../components/HomeSlider";
import {Search} from "../components/SearchBox";
import {DeckCards} from "../components/DeckCards";

export default class HomePage {
    init() {
        const config = {

            //Slider
            sliderDotsArrow: $('.js-slider-dots-arrow'),

            //SearchBox
            searchTrigger: $('.js-search-trigger'),
            header: $('.js-header'),
            main: $('.js-main'),
            footer: $('.js-footer'),
            searchClose: $('.js-search-close'),
            searchBox: $('.js-header-search'),

            deckCard : $('.card-deck__card')

        };

        let sliderArrows = new Slider(config);
        sliderArrows.init('.js-slider-dots-arrow', true, true, 600);

        let search = new Search(config);
        search.init();

        let deckCards = new DeckCards(config);
        deckCards.init();
    }
}


// WEBPACK FOOTER //
// ./static/js/pages/HomePage.js